import { createGlobalStyle } from "styled-components";

import PlusJakartaSansTTF from "assets/fonts/PlusJakartaSans/PlusJakartaSansVariable.ttf";

export default createGlobalStyle`
    @font-face {
        font-family: 'PlusJakartaSans';
        src: url(${PlusJakartaSansTTF}) format('truetype');
        font-style: normal;
        font-display: swap;
    }
`;
